// @ts-nocheck

import { useEffect } from 'react';

export const useLayerData = ({
  layerId,
  data,
  isLoading,
  error,
  layerManager,
  processor = null, // Optional data processor function
}) => {
  const { updateLayer, setLayerLoading, setLayerError, updateLayerOpacity } = layerManager;

  useEffect(() => {
    setLayerLoading(layerId, isLoading);
  }, [layerId, isLoading, setLayerLoading]);

  useEffect(() => {
    setLayerError(layerId, error);
  }, [layerId, error, setLayerError]);

  useEffect(() => {
    if (data && !isLoading && !error) {
      const processedData = processor ? processor(data) : data;
      updateLayerOpacity(layerId, layerId.includes('huc') || layerId.includes('FloodLayerTile') ? 0.4 : 0.7);
      updateLayer(layerId, processedData);
    }
  }, [data, isLoading, error, layerId, updateLayer, processor, updateLayerOpacity]);
};
